module.exports = __webpack_public_path__ + "static/media/cashflow_placeholder_nl.865d0ab6.png";